import { masterV2Api } from "@/apis/interceptor"
import { ISupervisorResponse, IResponse, ISupervisorParam } from "@/types"

export const supervisorsService = {
  getSupervisors: async (params: ISupervisorParam): Promise<IResponse<ISupervisorResponse>> => {
    const response = await masterV2Api.get<IResponse<ISupervisorResponse>>("/v1/supervisors", { params })
    return response.data
  },
}
